import React, { Component } from "react";
// import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import myplexAPI from "../../api/myplexAPI";
import { Link } from "react-router-dom";
// import Img from "../Uicomponents/Img";
import Img from "../../utils/similarContentImg";
// import { slugify } from "../../utils/stringSlugify";
import { slugify } from "../../../commonfiles/stringSlugify";
// import { carouselPatnerLogos } from "../../utils/partnerLogos";
// import LazyLoad from "react-lazyload";
// import {getURLName} from "../../utils/urlMenu";
import { getURLName } from "../../../commonfiles/urlMenu";

import { genres, languages } from "../../utils/portalhelper";
import sessionFun from "../../../commonfiles/SessionStorage";
import premium_badge_lock from "../../assets/images/premium_badge_lock.png";



// import carousel_freetag from "../../assets/images/freetag_thumbnail.png";
// import carousel_freetag from "../../assets/images/freetag_thumbnail.png";

export default class Recommended extends Component {
  state = {
    contents: [],
    pageName: "Home",
    trackingId: "",
    name:""
  };
  componentDidMount() {
    {
      this.props.ContentId && this._getSimilarContent();
    }
    
    const page_name = window.location.pathname.split("/")[1];
    if (page_name !== "") {
      this.setState({
        pageName: page_name,
      });
    }
    let name = "You May Also Like" ;
    if(this.props.type == "Myreco") {
      name = this.props.MyrecoData.title ;
    }
    if(this.props.info && this.props.info.generalInfo.type == "news"){
      name = "Related News";
    }    
    this.setState({
      name: name,
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.ContentId !== this.props.ContentId) {
      this._getSimilarContent();
      let name = "You May Also Like" ;
      if(this.props.type == "Myreco") {
        name = this.props.MyrecoData.title ;
      }
      if(this.props.info && this.props.info.generalInfo.type == "news"){
        name = "Related News";
      }    
      this.setState({
        name: name,
      });
    }

  }

  _getSimilarContent() {
    // console.log(this.props);
    if (this.props.type == "Myreco") {
      if(this.props.MyrecoData.name=="peopleAlsoWatchedWebReco"){
        myplexAPI
        .getSimilarContent(this.props.ContentId)
        .then((response) => { 
          this.setState({
            contents: response.data.results,
            trackingId: response.data.trackingId,
          });

        });
      }else{
        let Name = this.props.MyrecoData.name;
        let modified_on = this.props.MyrecoData.modified_on;
        let ID = this.props.ContentId;
        myplexAPI
        .getCarouselDataWithContentId(Name, "1", "10",modified_on, ID)
        .then((response) => { 
          this.setState({
            contents: response.data.results,
            trackingId: response.data.trackingId,
          });

        });
      
      }
      
    } else {
      var genresarr =
        this.props.info &&
        this.props.info.content &&
        this.props.info.content.genre;
      var languagesarr =
        this.props.info &&
        this.props.info.content &&
        this.props.info.content.language;
      var genre = genres(genresarr);
      var lang = languages(languagesarr);
      var type =
        this.props.info &&
        this.props.info.generalInfo &&
        this.props.info.generalInfo.type;
      var tags =
        this.props.info &&
        this.props.info.tags &&
        this.props.info.tags.values &&
        this.props.info.tags.values.length > 0 &&
        genres(this.props.info.tags.values);
      if (!tags) {
        tags = "";
      }

      myplexAPI
        .getFilterhResults(1, type, lang, genre, 25, tags)
        .then((response) => {
          if (this.props.tvepisode) {
            type = "tvseries";
            tags =
              this.props &&
              this.props.seriestags &&
              this.props.seriestags.values &&
              this.props.seriestags.values.length > 0 &&
              genres(this.props.seriestags.values);
          }
          // console.log(response);
          if (response.data.status === "SUCCESS") {
            this.setState({
              contents: response.data.results,
              trackingId: response.data.trackingId,
            });
          }
        });
    }
  }
  _getContent = () =>
    this.state.contents.map((content, i) => {
      // console.log(content)
      // let logo = null;
      // if (content.publishingHouse !== undefined) {
      //   let partnerLogos = carouselPatnerLogos(
      //     content.publishingHouse.publishingHouseName
      //   );
      //   if (partnerLogos.link !== undefined) {
      //     logo = (
      //       <LazyLoad once>
      //         <img
      //           src={partnerLogos.link}
      //           alt={partnerLogos.name}
      //           className="you_may_like_logo_patner"
      //         />
      //       </LazyLoad>
      //     );
      //   }
      // }
      if (content.generalInfo.type == "tvepisode") {
        var beautifytitle =
          content.generalInfo.title && content.generalInfo.title.split("|");
        var t = beautifytitle[0];
        if (beautifytitle[1]) {
          t = t + beautifytitle[1];
        }
        var url = `/${getURLName(content, this.state.pageName)}/detail/${
          content.generalInfo._id
        }/${slugify(content.globalServiceName)}/${slugify(t)}`;
      } else {
        var url = `/${getURLName(content, this.state.pageName)}/detail/${
          content.generalInfo._id
        }/${slugify(content.generalInfo.title)}`;
      }
      if (content._id !== this.props.ContentId) {
        return (
          <div key={i} className="carousel_img">
            <Link
              to={{
                pathname: url,
              }}
              key={i}
            >
              {/* {!content.generalInfo.isSellable &&
                content.generalInfo.contentRights &&
                content.generalInfo.contentRights[0] === "avod" && (
                  <div className="carousel_freetag">
                    <img src={carousel_freetag} alt="carousel_freetag" />
                  </div>
                )} */}
              
              <div
                className="recommended_data"
                onClick={() =>
                  this.sourceDetails(
                    i,
                    content.generalInfo._id,
                    this.state.pageName
                  )
                }
              >
                 
                <Img caroselimg={content} key={i} caroselname={this.props && this.props.type && this.props.type == "Myreco" ? this.props.MyrecoData.name : ''} />
                {/* {logo} */}
              </div>
              <div className="episodes-info">
                <span> {content.generalInfo.title}</span>
              </div>
            </Link>
            {content.generalInfo.accessLabel && sessionStorage.getItem("userPacks") != null && JSON.parse(sessionStorage.getItem("userPacks")).length <= 0 && (
                <div className="premium_badge_lock">
                  <img src={premium_badge_lock} alt="premium_badge_lock" />
                </div>
              )}
          </div>
        );
      } else {
        return null;
      }
    });
  sourceDetails = (i, id, pageName) => {
    setTimeout(function () {
      localStorage.setItem("source details", this.state.name);
      localStorage.setItem("trackingId",  this.state.trackingId);
      localStorage.getItem("os", "web");
      // localStorage.setItem("source", this.props.caroselinfo.title);
      localStorage.setItem("source", "carousel");
      sessionFun(
        // this.props.carousel_count,
        i,
        this.props.carosulcount,
        pageName,
        this.state.name,
        this.state.name,
        id
      );
    }.bind(this) , 5000);
  };
  render() {
    let perpage = 0;

    if (
      this.props.layoutType === "horizontalListBigItem" ||
      this.props.layoutType === "previewCarousel" ||
      this.props.layoutType === "roundedArtistCarousel"
    ) {
      perpage = 10;
    } else if (this.props.layoutType === "nestedCarousel") {
      perpage = 8;
    } else {
      perpage = 7;
    }

    const settings = {
      className: "center",
      dots: false,
      infinite: false,
      speed: 500,
      margin: 10,
      slidesToShow: 7,
      slidesToScroll: 10,
      loop: false,

      responsive: [
        {
          breakpoint: 1920,
          settings: {
            slidesToShow:
              perpage === 2 ? 2 : perpage === 10 ? 7 : perpage === 8 ? 4 : 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow:
              perpage === 2 ? 2 : perpage === 10 ? 4 : perpage === 8 ? 4 : 3,
            slidesToScroll: 4,
            arrows: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow:
              perpage === 2 ? 2 : perpage === 10 ? 3 : perpage === 8 ? 4 : 3,
            slidesToScroll: 3,
            arrows: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow:
              perpage === 2 ? 2 : perpage === 10 ? 3 : perpage === 8 ? 4 : 2,
            slidesToScroll: 3,
            arrows: false,
          },
        },
        {
          breakpoint: 360,
          settings: {
            slidesToShow:
              perpage === 2 ? 2 : perpage === 10 ? 3 : perpage === 8 ? 4 : 2,
            slidesToScroll: 2,
            arrows: false,
          },
        },
      ],
    };

    const events = {
      onDragged: function (event) {},
      onChanged: function (event) {},
    };
    // console.log(this.props.info.generalInfo.type);
    return this.props.info &&
      this.props.info.generalInfo &&
      this.props.info.generalInfo.type !== "live" ? (
      <div className="recommended_carousel">
        <div className="episodes_section">
          <div className="carousel_slider_section">
            <div className="center_caousel_item">
              <div className="carousel_body">
                <div className="home_carosel_title">
                  {this.state.contents.length > 0 &&
                  this.props.type == "Myreco" ? (
                    <h1>{this.props.MyrecoData.title}</h1>
                  ) : this.props.info.generalInfo.type == "news" ? (
                    <h1>Related News </h1>
                  ) :  this.state.contents.length > 1 ?
                    <h1>You May Also Like </h1> : null
                  }
                </div>
                <div className="carosel_slider">
                  {/* <img src={view_all_arrow_mm} className="view_all_arrow" alt="viewall_arrow_img" /> */}

                  {this.state.contents.length > 0 && (
                    <Slider {...settings}> {this._getContent()} </Slider>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : null;
  }
}
